import { Reveal } from "./Reveal";
import { GALLERY } from "../constants/contact";

const SPANS = ["lg:col-span-2", "", "", "", "", "", "lg:col-span-2"];

export const Gallery = ({ t }) => (
  <section id="galeria" className="relative mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-40" data-testid="gallery-section">
    <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
      <div className="lg:col-span-5">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold" data-testid="gallery-chapter">
            {t.gallery.chapter}
          </p>
          <h2 className="mt-4 font-display text-4xl tracking-tight text-bone sm:text-5xl" data-testid="gallery-title">
            {t.gallery.title}
          </h2>
          <div className="mt-6 h-px w-16 bg-gold" />
        </Reveal>
      </div>
      <div className="lg:col-span-7">
        <Reveal delay={0.1}>
          <p className="font-display text-2xl italic leading-snug text-bone sm:text-3xl" data-testid="gallery-heading">
            {t.gallery.heading}
          </p>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-bone/60" data-testid="gallery-sub">
            {t.gallery.sub}
          </p>
        </Reveal>
      </div>
    </div>

    <div className="mt-20 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="gallery-grid">
      {GALLERY.map((src, i) => (
        <Reveal key={src} delay={0.06 * i} className={SPANS[i % SPANS.length]}>
          <figure
            className="group relative h-72 overflow-hidden rounded-sm border border-white/10 sm:h-80"
            data-testid={`gallery-item-${i}`}
          >
            <img
              src={src}
              alt={t.gallery.captions[i]}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              data-testid={`gallery-image-${i}`}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
          </figure>
        </Reveal>
      ))}
    </div>
  </section>
);
